// extracted by mini-css-extract-plugin
export default {"receiptWrapper":"Receipt_receiptWrapper__AOBiR","inner":"Receipt_inner__drhXW","icon":"Receipt_icon__4Sd5T"};